import React from "react";
import { Row } from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

const About = () => (
  <section id="how">
    <h2 class="txt-title text-center txt-landing"><Trans>Simplify Your Accounting with Hesaab</Trans></h2>
    <Row className="justify-content-center text-center hiw hw-works py-2">
      <div className="col-12 col-lg-12 text-center">
        <Row>
          <div className="col-sm my-3">
            <img
              className="img-fluid md-icon"
              src="/images/landing/features/support-icon.svg"
              alt="Exceptional Customer Support"
            />
            <h6 className="mt-2 my-3">
              <Trans>Exceptional Customer Support</Trans>
            </h6>
            <p>
              <Trans>Receive expert assistance from our dedicated support team</Trans>
            </p>
          </div>

          <div className="col-sm my-3">
            <img
              className="img-fluid md-icon"
              src="/images/landing/features/worldwide-icon.svg"
              alt="Trusted by Businesses Worldwide"
            />
            <h6 className="mt-2 my-3">
              <Trans>Trusted by Businesses Worldwide</Trans>
            </h6>
            <p>
              <Trans>Join a growing community that relies on Hesaab for seamless accounting solutions.</Trans>
            </p>
          </div>

          <div className="col-sm my-3">
            <img
              className="img-fluid md-icon"
              src="/images/landing/features/secure-icon.svg"
              alt="Secure and Reliable"
            />
            <h6 className="mt-2 my-3">
              <Trans>Secure and Reliable</Trans>
            </h6>
            <p>
              <Trans>Industry-standard security measures ensure your data is always protected.</Trans>
            </p>
          </div>

        </Row>

        <Row className="justify-content-center text-center hw-works">
          <div className="col-sm my-3">
            <img
              className="img-fluid md-icon"
              src="/images/landing/features/scalable-icon.svg"
              alt="Scalable for Every Business"
            />
            <h6 className="mt-2 my-3">
              <Trans>Scalable for Every Business</Trans>
            </h6>
            <p>
              <Trans>Whether you’re a small business or a large enterprise, our solutions grow with you.</Trans>
            </p>
          </div>

          <div className="col-sm my-3">
            <img
              className="img-fluid md-icon"
              src="/images/landing/features/user-friendly-icon.svg"
              alt="User-Friendly Interface"
            />
            <h6 className="mt-2 my-3">
              <Trans>User-Friendly Interface</Trans>
            </h6>
            <p>
              <Trans>Enjoy a clean, intuitive platform designed for ease of use and efficiency.</Trans>
            </p>
          </div>

          <div className="col-sm my-3">

            <img
              className="img-fluid md-icon"
              src="/images/landing/features/integration-icon.svg"
              alt="Fast and Seamless Integration"
            />
            <h6 className="mt-2 my-3">
              <Trans>Fast and Seamless Integration</Trans>
            </h6>
            <p>
              <Trans>Integrate quickly with Xero and other applications manage your business in one place.</Trans>
            </p>
          </div>

        </Row>
      </div>

    </Row>
  </section>
);

export default About;
